module.exports = __webpack_public_path__ + "img/platform4.8d8cc736.png";